import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-notification-counter',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './notification-counter.component.html',
  styleUrl: './notification-counter.component.css',
})
export class NotificationCounterComponent {
  @Input() counter: number;
}
